import { client } from './client'
import { getErrorStatus } from './errors'
import type {
  SecurityReviewRun,
  SecurityReviewFinding,
  SetSecurityReviewFindingDecisionRequest,
  PaginationParams,
  PagedResult,
} from '@/types'

interface SecurityReviewFindingFilters {
  sortBy?: string
  sortDirection?: 'asc' | 'desc'
}

export const securityReviewApi = {
  getRunByWorkflowRunId: (projectId: string, workflowRunId: string): Promise<SecurityReviewRun | null> =>
    client
      .get<SecurityReviewRun>(`/projects/${projectId}/security-review/workflow-runs/${workflowRunId}`)
      .then(r => r.data)
      .catch((error: unknown) => {
        if (getErrorStatus(error) === 404) return null
        throw error
      }),

  getFindings: (
    projectId: string,
    securityReviewRunId: string,
    params?: PaginationParams & SecurityReviewFindingFilters,
  ) =>
    client
      .get<PagedResult<SecurityReviewFinding>>(
        `/projects/${projectId}/security-review/runs/${securityReviewRunId}/findings`,
        { params },
      )
      .then(r => r.data),

  setFindingDecision: (projectId: string, findingId: string, data: SetSecurityReviewFindingDecisionRequest) =>
    client
      .put(`/projects/${projectId}/security-review/findings/${findingId}/decision`, data)
      .then(r => r.data),
}
